import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CleanuupAdministrationComponent } from './component/cleanup-administration.component';

const routes: Routes = [
  { path: '', component: CleanuupAdministrationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CLeanupAdministrationRoutingModule { }
